<template>
  <!-- 交易详情 -->
  <div id="T_Details">
    <!-- 内容区域 -->
    <!-- <head>
      <link rel="stylesheet" href="https://cdn.bootcss.com/material-design-icons/3.0.1/iconfont/material-icons.css">
    </head> -->
    <!-- <div style="width: 100%; background: #fff;"> -->

    <mu-flex direction="column" style="width: 100%;height: 100%;">

      <mu-flex class="is-full-width">
        <!-- <mu-appbar style="width: 100%;" color="primary">
  <mu-button icon slot="left">
    <mu-icon value="menu"></mu-icon>
  </mu-button>
  Title

  <mu-button flat slot="right">LOGIN</mu-button> -->
        </mu-appbar>
        <mu-appbar class="is-full-width" v-bind:title="titleStr" color="#fff" textColor="#303644" z-depth=0>
          <mu-button @click="leftBtn" icon slot="left">
            <mu-icon value="arrow_back"></mu-icon>
          </mu-button>
          <mu-button @click="rightBtn" icon slot="right">
            <mu-icon value="menu"></mu-icon>
          </mu-button>
        </mu-appbar>

      </mu-flex>

      <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
        <!-- <HomeList style="height: 100%; width: 100%;"></HomeList> -->
        <!-- <div style="background-color: #00695C; width: 100%;height: 100%;"></div> -->
        <mu-flex direction="column" style="height: 100%; width: 100%;">
          <TDetailsHead ref="TDetailsHead" style="width: 100%;"></TDetailsHead>
          <TDetailsLegenda ref="TDetailsLegenda" style="width: 100%;"></TDetailsLegenda>
          <!-- <mu-flex class="is-full-width content" fill> -->
          <TDetailsList ref="TDetailsList" style="width: 100%;" fill></TDetailsList>
          <!-- </mu-flex> -->
        </mu-flex>
      </mu-flex>

      <mu-flex class="is-full-width BottomFlex">
        <mu-button @click="submit01" class="flex-demo Bottom_01" color="secondary" fill>
          <!-- <mu-icon left value="android"></mu-icon> -->
          <img src="../../../assets/image/buy.png" style="height: 1.875rem;width: 1.875rem;" />
            {{CurrentData.bidPx}}  Buy fall
        </mu-button>
        <mu-button @click="submit02" class="flex-demo Bottom_02" color="secondary" fill>
          <!-- <mu-icon left value="android"></mu-icon> -->
          <img src="../../../assets/image/up.png" style="height: 1.875rem;width: 1.875rem;" />
            {{CurrentData.bidPx}}  Buy up
        </mu-button>
      </mu-flex>

    </mu-flex>



    <!-- </div> -->
    <!--
      	</div> -->

    <!-- <div style="width: 100%; background: #fff; padding: 0px;">
        <mu-flex direction="column" style="width: 100%;height: 100vh;">

          <mu-flex class="is-full-width">
            <mu-appbar class="is-full-width" title="LocalBTC" color="#F8F8F8" textColor="#303644"></mu-appbar>
          </mu-flex>
          <mu-flex class="is-full-width" fill>

              <HomeList style="height: 100%; width: 100%;"></HomeList>
          </mu-flex>

          <mu-flex class="is-full-width">
            <mu-container>
              <mu-bottom-nav>
                <mu-bottom-nav-item title="Assets" icon=" " class="nav0"></mu-bottom-nav-item>
                <mu-bottom-nav-item title="Transaction" icon=" " class="nav1"></mu-bottom-nav-item>
                <mu-bottom-nav-item title="OTC" icon=" " class="nav2"></mu-bottom-nav-item>
                <mu-bottom-nav-item title="Personal" icon=" " class="nav3"></mu-bottom-nav-item>
              </mu-bottom-nav>
            </mu-container>
          </mu-flex>
        </mu-flex>

      </div> -->
    <el-dialog title="Place an Order" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="Quantity" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off" οnkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-radio-group v-model="radio">
          <el-radio :label="1">X1  </el-radio>
          <el-radio v-if="UserType > 0" :label="5">X5  </el-radio>
          <el-radio v-if="UserType > 0" :label="10">X10</el-radio>
          <el-radio v-if="UserType > 0" :label="15">X15</el-radio>
          <el-radio v-if="UserType > 0" :label="20">X20</el-radio>
          <el-radio v-if="UserType > 1" :label="30">X30</el-radio>
          <el-radio v-if="UserType > 1" :label="50">X50</el-radio>
          <el-radio v-if="UserType > 1" :label="80">X80</el-radio>
          <el-radio v-if="UserType > 1" :label="100">X100</el-radio>
        </el-radio-group>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="BuyIns">Buy-ins</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  import TDetailsHead from './T_Details_Head.vue'
  import TDetailsLegenda from './T_Details_Legenda.vue'
  import TDetailsList from './T_Details_List.vue'
  export default {
    data() {
      return {
        // mailStr: '',
        titleStr: '',
        CurrentData: {},
        TakerVolume: [],
        ListID: 0,
        DDY: 0,
        radio: 1,
        dialogFormVisible: false,
        form: {
          name: '0.0',
          type: []
        },
        formLabelWidth: '70px',
        UserType:0
      }
    },
    mounted() {
      var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
      this.UserType = UserInfo.type;

      window.T_Details = this;
      this.titleStr = this.$route.query.instId;
      // console.log(this.$route.query.instId);
      // v-bind:title="totalmoney"

      this.loadData();
      this.loadTakerVolume();
      this.loadLegendaData();
      setInterval(() => { //setInterval换个名字就行了
        // console.log(this.$route.path);
        if (this.$route.path != '/M/T_Details') return;
        this.loadData();
        this.loadLegendaData();
      }, 5 * 1000); //设置时间，这里是5秒
      setInterval(() => { //setInterval换个名字就行了
        // console.log(this.$route.path);
        if (this.$route.path != '/M/T_Details') return;
        this.loadTakerVolume();
      }, 4 * 60 * 1000); //设置时间，这里是60秒
    },
    methods: {
      leftBtn() {
        this.$router.go(-1); //返回上一层
      },
      rightBtn() {
        this.$router.push({
          path: '/M/Order',
          query: {
            instId:this.titleStr
          }
        })
      },
      loadData() {
        const that = this;

        let params = new URLSearchParams();
        params.append('instId', this.titleStr);
		params.append('token',sStorage.getItem("token"));
        this.$http.get('/price/CurrentPrice', {
            params
          })
          .then(function(response) {
            // console.log(response.data);
            // that.refreshing = false;
            if (response.data.success || response.data.code == 1) {
              that.CurrentData = response.data.content;
              that.$refs.TDetailsHead.setCurrentData(that.CurrentData);
              // window.T_Details_Head.setCurrentData(that.CurrentData);
              // window.login.$message(response.data.message);
              // var content = response.data.content;
              // that.totalmoney = "$" + content.totalMoney;
              // function upData(a, b) {
              //   if (a.instId == "btc-usd-swap") return -1;
              //   else if (b.instId == "btc-usd-swap") return 0;
              //   else if (a.instId == "eth-usd-swap") return -1;
              //   else if (b.instId == "eth-usd-swap") return 0;
              //   return 1;
              // };
              // console.log(response.data.content.sort(upData));
              // that.tableData = response.data.content.sort(upData);
            } else {
              that.$message.error(response.data.message);
            }
          });
      },
      loadTakerVolume() {
        const that = this;

        let params = new URLSearchParams();
        params.append('instId', this.titleStr);
		params.append('token',sStorage.getItem("token"));
        this.$http.get('/price/TakerVolume', {
            params
          })
          .then(function(response) {
            // console.log(response.data);
            // that.refreshing = false;
            if (response.data.success || response.data.code == 1) {
              that.TakerVolume = response.data.content;
              that.$refs.TDetailsList.setTableData(that.TakerVolume);
              // window.T_Details_Head.setCurrentData(that.CurrentData);
              // window.login.$message(response.data.message);
              // var content = response.data.content;
              // that.totalmoney = "$" + content.totalMoney;
              // function upData(a, b) {
              //   if (a.instId == "btc-usd-swap") return -1;
              //   else if (b.instId == "btc-usd-swap") return 0;
              //   else if (a.instId == "eth-usd-swap") return -1;
              //   else if (b.instId == "eth-usd-swap") return 0;
              //   return 1;
              // };
              // console.log(response.data.content.sort(upData));
              // that.tableData = response.data.content.sort(upData);
            } else {
              that.$message.error(response.data.message);
            }
          });
      },
      loadLegendaData() {
          const that = this;

          let params = new URLSearchParams();
          params.append('instId', this.titleStr);
      params.append('token',sStorage.getItem("token"));
          this.$http.get('/price/PriceCandles', {
              params
            })
            .then(function(response) {
              // console.log(response.data);
              // that.refreshing = false;
              if (response.data.success || response.data.code == 1) {
                that.$refs.TDetailsLegenda.setLegendaData(response.data.content[0],response.data.content[1]);
              } else {
                that.$message.error(response.data.message);
              }
            });
        },
      submit01() {
        this.dialogFormVisible = true;
        this.ListID = this.CurrentData.id;
        this.DDY = 0;
      },
      submit02() {
        this.dialogFormVisible = true;
        this.ListID = this.CurrentData.id;
        this.DDY = 1;
      },
      BuyIns() {
        this.dialogFormVisible = false;
        console.log(this.form.name);
        console.log(this.radio);
        if (this.form.name <= 0) {
          this.$message.error('Gli acquisti sono stati effettuati per errore');
          return;
        }

        let params = new URLSearchParams();
        params.append('instId', this.titleStr);
        params.append('priceId', this.ListID);
        params.append('count', this.form.name);
        params.append('DDY', this.DDY);
        params.append('times', this.radio);
		params.append('token',sStorage.getItem("token"));

          const that = this;
        this.$http.post('/order/Place', params)
          .then(function(response) {
            console.log(response.data);
            if (response.data.success || response.data.code == 1) {
              that.dialogFormVisible = false;
              that.$message(response.data.message);
            }else if (response.data.code == -1){
              sStorage.clear();
              that.$router.replace("/");
              that.$message.error(response.data.message);
            } else {
              that.$message.error(response.data.message);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    components: {
      TDetailsHead,
      TDetailsLegenda,
      TDetailsList
    }
  };
</script>

<style>
  @import '../../../../Comm/css/CommCSS.css';
/*  #T_Details .mu-appbar .mu-appbar-title {
    text-align: center;
  } */

  #T_Details .is-full-width {
    width: 100%;
  }

  #T_Details .content {
    flex: 1
  }

  #T_Details .BottomFlex {
    width: 100%;
    height: 60px;
  }

  #T_Details .Bottom_01 {
    width: 50%;
    height: 100%;
    background-color: #aa2116;
    border-radius: 0px;
  }

  /* #T_Details .Bottom_01 .mu-icon {
    background-image: url(../../../assets/image/btn_1_1.png)
  } */
  #T_Details .Bottom_02 {
    width: 50%;
    height: 100%;
    background-color: #225a1f;
    border-radius: 0px;
  }

  #T_Details .el-dialog {
    width: 90%;
    margin: 0 auto;
    /* transform: translate(0px, 0px); */
  }
  #T_Details .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        top: -15vh;
  }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Transaction/Details/T_Details.vue